import { useAtomValue } from 'jotai';
import { useUserTDK } from '../shared/use-user-tdk';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { CommonPageOGCard, EOGType, ICommonPageOGCardProps, IOGImage } from '@lemon8/web-app-shared/ssr';
import { $PageLevelTraffic } from 'shared/atoms';
import { loadable } from 'jotai/utils';

export const UserOpenGraph = () => {
  const canonicalUrl = useAtomValue($PageLevelTraffic).canonicalUrl;
  const { title, description } = useUserTDK();
  const loadableUser = useAtomValue(loadable($CurrentAvailableUserOrNull));

  const getOGImageMeta: () => IOGImage | null = () => {
    if (loadableUser.state !== 'hasData' || !loadableUser.data) {
      return null;
    }
    return loadableUser.data.avatar
      ? {
          url: loadableUser.data.avatar
            .replace(/p16-(sign-)?va\.lemon8cdn.com/g, 'p16-va.topbuzzcdn.com')
            .replace(/p16-(sign-)?sg\.lemon8cdn.com/g, 'p16.topbuzzcdn.com'),
        }
      : null;
  };

  const ogCardInfo: ICommonPageOGCardProps = {
    ogUrl: canonicalUrl,
    ogTitle: title,
    ogDescription: description,
    ogMediaMetaInfo: getOGImageMeta(),
    // Temperately set all card as OG Article type
    ogType: EOGType.Article,
  };
  return <CommonPageOGCard {...ogCardInfo} />;
};
